<script setup lang="ts">
import { useAppLayout } from '@/composables/useAppLayout'
import AppSidebarContent from '@/components/AppSidebarContent.vue'
import { Sheet, SheetContent } from '@kyoto2/components/ui/sheet'

const { isDesktop, mobileNavOpen, closeMobileNav } = useAppLayout()
</script>

<template>
  <aside class="hidden lg:flex w-60 border-r border-border bg-muted/30 flex-col h-full shrink-0">
    <AppSidebarContent />
  </aside>

  <Sheet v-if="!isDesktop" :open="mobileNavOpen" @update:open="(open) => !open && closeMobileNav()">
    <SheetContent side="left" class="w-[min(100vw,15rem)] p-0 gap-0 bg-background">
      <AppSidebarContent compact @navigate="closeMobileNav" />
    </SheetContent>
  </Sheet>
</template>
